/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Unavailable_PracticeInputs */



/**
* | output |
* | --- |
* | "Go to Practice" |
*
* @param {Demo_Unavailable_PracticeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const demo_unavailable_practice = /** @type {((inputs?: Demo_Unavailable_PracticeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Unavailable_PracticeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Naar Oefenen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vers l'entraînement")
	return /** @type {LocalizedString} */ ("Go to Practice")
});